import WishList from "./wishlist.js";
var App = App || {};

App.LandingPage = {
    init: function () {
        this.cacheDOMElements();
        this.bindEvents();
        this.initSliders();
        this.initJudgemeReviewTexts();
    },

    cacheDOMElements: function () {
        this.window = window;
        this.accumulator = document.getElementsByClassName("accordion");
        this.ingredientsHeader = document.getElementById("ingredients__header");
        if (this.ingredientsHeader) {
            this.ingredientsTabs =
                this.ingredientsHeader.getElementsByClassName("tab");
            this.ingredientsContentContainer = document.getElementById(
                "ingredients__content",
            );
            this.ingredientsContentTabs =
                this.ingredientsContentContainer.getElementsByClassName(
                    "content__tab",
                );
        }

        this.cartButton = document.getElementById("cart-button");
        this.cartSidebar = document.getElementById("cart-sidebar");
        this.cartOverlay = document.getElementById("cart-overlay");
        this.mobileMenu = document.getElementById("mobile-menu");
        this.buttonMobileMenu = document.getElementById("button__mobile-menu");
        this.document = document;
        this.btnShowPassword =
            document.getElementsByClassName("btnShowPassword");
        this.passwordInput = document.querySelector(
            'input[name="customer[password]"]',
        );
        this.campoSenha = document.getElementById("password1");
        this.campoConfirma = document.getElementById("confirmPassword");
        this.navItems = document.querySelectorAll(".account");
        this.tabs = document.querySelectorAll(".tab-pane");
        this.backBtns = document.querySelectorAll(".back-btn");

        this.form = document.querySelector(
            'form[action*="/account/addresses"]',
        );
        this.btnSubmit = document.getElementById("btn_submit_address");
        this.formDelete = document.getElementById("form-address__delete");
        this.btnAddCart = document.querySelectorAll("[data-variant]");
        this.btnRemoveFromCart = document.querySelectorAll(
            "[data-variant-cart]",
        );
        this.buttonsPlus = document.querySelectorAll(
            "[data-variant-cart-plus]",
        );
        this.buttonsMinus = document.querySelectorAll(
            "[data-variant-cart-minus]",
        );
        this.btnGoToStep = document.getElementsByClassName("goToStep");
        this.formCheckout = document.getElementById("preCheckoutForm");
        this.falseAnchor = document.getElementById("false-anchor");
        this.variantTexts = document.getElementsByClassName("js-variant-text");
        this.previewImage = document.getElementById("preview-variant-product");
        /* #region(collapsed) Sliders  */
        this.sliderHero = document.getElementById("sliderHero");
        this.sliderStick = document.getElementById("sliderSticks");
        this.sliderRollon = document.getElementById("sliderRoll-On");
        this.sliderSpray = document.getElementById("sliderSprays");
        this.sliderAbout = document.getElementById("sliderAbout");
        this.sliderSpecialities = document.getElementById("sliderSpecialities");
        this.sliderProduct = document.getElementById("sliderProduct");
        this.sliderRelatedProducts = document.getElementById(
            "sliderRelatedProducts",
        );
        this.thumbnails = document.getElementById("thumbnails");
        this.sliderTags = document.getElementById("sliderTags");
        this.sliderSpecifications = document.getElementById(
            "sliderSpecification",
        );
        /* #endregion */
    },

    bindEvents: function () {
        /* #region(collapsed) Tabs Handler */
        if (this.ingredientsHeader) {
            for (let i = 0; i < this.ingredientsTabs.length; i++) {
                const tab = this.ingredientsTabs[i];
                tab.addEventListener("click", () =>
                    this.Events.handlerTabs(i, this),
                );
            }
        }
        /* #endregion */

        /* #region(collapsed) Acordion Handler   */
        if (this.accumulator.length > 0) {
            for (let i = 0; i < this.accumulator.length; i++) {
                this.accumulator[i].addEventListener("click", () =>
                    this.Events.handlerAccordion(i),
                );
            }
        }
        /* #endregion */

        /* #region(collapsed) Menu Mobile */
        this.cartButton.addEventListener(
            "click",
            this.Events.openCart.bind(this),
        );
        this.cartOverlay.addEventListener(
            "click",
            this.Events.closeCart.bind(this),
        );

        document.addEventListener("click", (e) => {
            const element = e.target;
            if (element.closest("#button-inside-cart")) {
                this.Events.closeCart.call(this);
            }
            if (element.matches("[data-variant-cart]")) {
                const variant = element.getAttribute("data-variant-cart");
                this.Events.removerDoCarrinho(variant);
            }
            if (element.matches("[data-variant-cart-minus]")) {
                const value = element.getAttribute("value");
                const variant = element.getAttribute("data-variant-cart-minus");
                this.Events.changeQuantity(variant, value);
            }
            if (element.matches("[data-variant-cart-plus]")) {
                const value = element.getAttribute("value");
                const variant = element.getAttribute("data-variant-cart-plus");

                this.Events.changeQuantity(variant, value);
            }
        });

        this.buttonMobileMenu.addEventListener(
            "click",
            this.Events.handlerMobileMenu.bind(this),
        );
        /* #endregion */

        this.document.addEventListener("click", (e) => {
            const btn = e.target.closest("[data-copy]");
            if (!btn) return;

            navigator.clipboard.writeText(btn.dataset.copy).then(() => {
                btn.innerText = "Copiado!";
            });
        });

        /* #region(collapsed) Password */
        for (let i = 0; i < this.btnShowPassword.length; i++) {
            const element = this.btnShowPassword[i];
            element.addEventListener("click", () =>
                this.Events.handlePasswordInput(element),
            );
        }

        if (this.campoSenha) {
            this.campoSenha.addEventListener(
                "input",
                this.Events.validarTudo.bind(this),
            );
            this.campoConfirma.addEventListener(
                "input",
                this.Events.validarTudo.bind(this),
            );
        }
        /* #endregion */

        if (this.navItems.length > 0) {
            this.navItems.forEach((item) => {
                item.addEventListener("click", () => {
                    // Remove ativo de todos
                    this.tabs.forEach((t) => t.classList.remove("active"));

                    console.log(this.tabs);
                    // Adiciona ativo no alvo
                    const targetId = item.getAttribute("data-target");
                    const targetTab = document.getElementById(targetId);
                    if (targetTab) targetTab.classList.add("active");
                });
            });

            // Função para voltar (Mobile)
            this.backBtns.forEach((btn) => {
                btn.addEventListener("click", () => {
                    // Remove ativo da aba pai
                    btn.closest(".tab-pane").classList.remove("active");
                });
            });
        }

        /* #region(collapsed) Address Form */
        if (this.btnSubmit && this.form) {
            this.btnSubmit.addEventListener("click", function (e) {
                const rua = document.getElementById("input_street").value || "";
                const numero =
                    document.getElementById("input_number").value || "S/N";
                const bairro =
                    document.getElementById("input_neighborhood").value || "";
                const complemento =
                    document.getElementById("input_complement").value || "";

                // Address 1 = "Rua das Flores, 123"
                const finalAddress1 = `${rua}, ${numero}`;

                // Address 2 = "Apto 101 - Centro" (Complemento - Bairro)
                let finalAddress2 = bairro;
                if (complemento) {
                    finalAddress2 = `${complemento} - ${bairro}`;
                }

                document.getElementById("real_address1").value = finalAddress1;
                document.getElementById("real_address2").value = finalAddress2;
            });
        }

        if (this.formDelete) {
            this.formDelete.addEventListener("submit", function (event) {
                // 1. Impede o formulário de recarregar a página imediatamente
                event.preventDefault();

                const form = event.target;
                const actionUrl = form.getAttribute("action");
                const formData = new FormData(form);

                // 2. Envia a requisição de exclusão para a Shopify em segundo plano
                fetch(actionUrl, {
                    method: "POST",
                    body: formData,
                })
                    .then((response) => {
                        // 3. Se a requisição funcionou (ou mesmo se redirecionou),
                        // forçamos o navegador a ir para a página da conta
                        window.location.href = "/account";
                    })
                    .catch((error) => {
                        console.error("Erro ao excluir:", error);
                        // Opcional: alert('Houve um erro ao excluir o endereço.');
                    });
            });
        }

        /* #endregion */

        if (this.btnAddCart.length > 0) {
            for (let i = 0; i < this.btnAddCart.length; i++) {
                const element = this.btnAddCart[i];
                const variant = element.getAttribute("data-variant");
                element.addEventListener("click", () =>
                    this.Events.adicionarAoCarrinho.call(this, variant, 1),
                );
            }
        }
        if (this.btnGoToStep.length > 0) {
            let array = this.btnGoToStep;
            for (let i = 0; i < array.length; i++) {
                const element = array[i];

                element.addEventListener("click", () =>
                    this.Events.goToStep(element),
                );
            }
        }

        if (this.formCheckout) {
            this.formCheckout.addEventListener("submit", (e) =>
                this.Events.handleFormCheckout(e, this),
            );
        }

        if (this.falseAnchor) {
            const href = this.falseAnchor.getAttribute("data-href");
            if (href) {
                this.falseAnchor.addEventListener(
                    "click",
                    () => (window.location = href),
                );
            }
        }

        if (this.variantTexts.length > 0) {
            let array = this.variantTexts;
            for (let i = 0; i < array.length; i++) {
                const element = array[i];
                const dataSrc =
                    element.nextElementSibling.getAttribute("data-src");
                element.addEventListener("mouseover", () => {
                    this.previewImage.classList.remove("opacity-0");
                    this.previewImage.src = dataSrc;
                });
                element.addEventListener("mouseout", () => {
                    this.previewImage.classList.add("opacity-0");
                    this.previewImage.src = dataSrc;
                });
            }
        }
    },

    Events: {
        openCart: function () {
            this.cartSidebar.classList.remove("translate-x-full");
            this.cartOverlay.classList.remove(
                "opacity-0",
                "pointer-events-none",
            );
            document.body.style.overflow = "hidden";

            const sectionFilename = "cart-sidebar"; // NÃO ALTERE
            fetch(`/?section_id=${sectionFilename}`)
                .then((response) => response.text())
                .then((responseText) => {
                    const parser = new DOMParser();
                    const html = parser.parseFromString(
                        responseText,
                        "text/html",
                    );
                    const newSidebarContent =
                        html.getElementById("cart-sidebar");

                    if (newSidebarContent && this.cartSidebar) {
                        this.cartSidebar.innerHTML =
                            newSidebarContent.innerHTML;
                    }
                })
                .catch((error) => {
                    console.error("Erro ao atualizar o carrinho:", error);
                });
        },

        closeCart: function () {
            this.cartSidebar.classList.add("translate-x-full");
            this.cartOverlay.classList.add("opacity-0", "pointer-events-none");

            document.body.style.overflow = "";
        },

        handlerMobileMenu: function () {
            this.mobileMenu.classList.toggle("active");
        },

        handlerAccordion: function (i) {
            let self = App.LandingPage;
            let selfAcc = self.accumulator;
            let panel = selfAcc[i].nextElementSibling;

            for (let j = 0; j < selfAcc.length; j++) {
                if (j !== i) {
                    const panel = selfAcc[j].nextElementSibling;
                    selfAcc[j].classList.remove("active");
                    panel.style.maxHeight = null;
                }
            }

            selfAcc[i].classList.toggle("active");

            if (panel.style.maxHeight) panel.style.maxHeight = null;
            else panel.style.maxHeight = panel.scrollHeight + "px";
        },

        handlerTabs: function (i, self) {
            const contentTabs = self.ingredientsContentTabs;
            const tabsHeader = self.ingredientsTabs;

            for (let j = 0; j < contentTabs.length; j++) {
                const el = contentTabs[j];
                if (i == j) {
                    tabsHeader[i].classList.add("active");
                    el.classList.remove("hidden");
                    continue;
                }
                tabsHeader[j].classList.remove("active");
                el.classList.add("hidden");
            }
        },

        handlePasswordInput: function (el) {
            const input = el.previousElementSibling;
            const isPassword = input.type === "password";

            input.type = isPassword ? "text" : "password";
        },

        validarTudo: function () {
            const senha = this.campoSenha.value;
            const confirma = this.campoConfirma.value;

            function atualizarRegra(dataAttribute, condicao) {
                const iconTrue = document.querySelector(
                    `[data-${dataAttribute}="true"]`,
                );
                const iconFalse = document.querySelector(
                    `[data-${dataAttribute}="false"]`,
                );

                if (!iconTrue || !iconFalse) return;

                if (condicao) {
                    iconTrue.classList.remove("hidden");
                    iconFalse.classList.add("hidden");
                } else {
                    iconTrue.classList.add("hidden");
                    iconFalse.classList.remove("hidden");
                }
            }

            atualizarRegra("min8", senha.length >= 8);
            atualizarRegra(
                "minspecialchar",
                /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha),
            );
            atualizarRegra("minonelowercase", /[a-z]/.test(senha));
            atualizarRegra("minoneuppercase", /[A-Z]/.test(senha));
            atualizarRegra("minonenumber", /[0-9]/.test(senha));

            // Verifica se são iguais E se não estão vazios
            const saoIguais = senha === confirma && senha.length > 0;
            atualizarRegra("match", saoIguais);
        },

        adicionarAoCarrinho: function (variantId, quantidade) {
            let formData = {
                items: [
                    {
                        id: variantId,
                        quantity: quantidade,
                    },
                ],
            };

            fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
                .then(() => {
                    this.Events.openCart.call(this);
                })
                .catch((error) => {
                    console.error("Erro:", error);
                });
        },

        removerDoCarrinho: function (variant) {
            fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: variant, // ou 'line': 1
                    quantity: 0,
                }),
            })
                .then((response) => response.json())
                .then((cart) => {
                    console.log("Item removido. Novo total:", cart.item_count);
                    location.reload(); // Opcional: recarrega para ver a mudança
                });
        },

        changeQuantity: function (variant, novaQuantidade) {
            fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: variant,
                    quantity: novaQuantidade,
                }),
            })
                .then((response) => response.json())
                .then((cart) => {
                    location.reload();
                });
        },

        goToStep: function (el) {
            const step = el.getAttribute("data-step");

            document
                .querySelectorAll(".step-content")
                .forEach((el) => (el.style.display = "none"));

            // Mostra o passo solicitado
            document.getElementById("checkout__content-" + step).style.display =
                "block";

            // window.scrollTo(0, 0);
        },

        handleFormCheckout: async function (e, self) {
            e.preventDefault(); // Impede o envio padrão do formulário

            const form = e.target;
            const submitBtn = form.querySelector('button[type="submit"]');

            // Muda texto do botão para dar feedback
            const originalBtnText = submitBtn.innerText;
            submitBtn.innerText = "Processando...";
            submitBtn.disabled = true;

            const restoreButton = () => {
                submitBtn.innerText = originalBtnText;
                submitBtn.disabled = false;
            };

            try {
                // 1. Confere se o carrinho tem itens.
                //    Importante: NÃO montamos mais um cart permalink
                //    (/cart/{variant}:{qty}), porque ele recria o carrinho do
                //    zero e descarta descontos automáticos, cupons aplicados
                //    e atributos já gravados.
                const cart = await fetch("/cart.js").then((r) => r.json());

                if (cart.item_count === 0) {
                    alert("Seu carrinho está vazio!");
                    restoreButton();
                    return;
                }

                const formData = new FormData(form);

                // 2. CPF gravado como atributo do carrinho (aparece no Admin),
                //    mesmo padrão de snippets/cep-checkout-prefill.liquid
                await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        attributes: {
                            CPF: formData.get("customer[note][cpf]") || "",
                        },
                    }),
                });

                // 3. Mapeia os campos do formulário para os parâmetros da Shopify
                const params = new URLSearchParams();

                // E-mail
                params.append(
                    "checkout[email]",
                    formData.get("customer[email]"),
                );

                // Endereço de Entrega
                params.append(
                    "checkout[shipping_address][first_name]",
                    formData.get("customer[first_name]"),
                );
                params.append(
                    "checkout[shipping_address][last_name]",
                    formData.get("customer[last_name]"),
                );
                params.append(
                    "checkout[shipping_address][phone]",
                    formData.get("customer[phone]"),
                );

                const logradouro = formData.get("address[address1]") || "";
                const numero = formData.get("address[number]") || "";
                params.append(
                    "checkout[shipping_address][address1]",
                    numero ? `${logradouro}, ${numero}` : logradouro,
                ); // Logradouro + Número
                const complemento = formData.get("address[address2]") || "";
                const bairro = formData.get("address[neighborhood]") || "";
                params.append(
                    "checkout[shipping_address][address2]",
                    [complemento, bairro].filter(Boolean).join(", "),
                ); // Complemento + Bairro
                params.append(
                    "checkout[shipping_address][city]",
                    formData.get("address[city]"),
                );
                params.append(
                    "checkout[shipping_address][province]",
                    formData.get("address[province]"),
                ); // Estado (Sigla)
                params.append(
                    "checkout[shipping_address][zip]",
                    formData.get("address[zip]"),
                );
                params.append("checkout[shipping_address][country]", "Brazil");

                // 4. Vai para o checkout preservando o carrinho atual
                window.location.href = "/checkout?" + params.toString();
            } catch (error) {
                console.error("Erro ao processar carrinho:", error);
                alert("Ocorreu um erro ao ir para o checkout. Tente novamente.");
                restoreButton();
            }
        },
    },

    initSliders: function () {
        this.Utils.waitForElement("#sliderRelatedProducts")
            .then((el) => {
                if (el.dataset.sliderInit) return; // evita duplicar

                this.sliderRelatedProducts = el;

                this.Utils.initSlider(this.sliderRelatedProducts, {
                    slides: {
                        perView: 1.2,
                        spacing: 15,
                    },
                });

                el.dataset.sliderInit = "1";
            })
            .catch((err) => console.warn(err));

        this.Utils.initSlider(
            this.sliderHero,
            {
                loop: true,
            },
            this.Utils.navigationSliderOnlyDots,
        );

        /* #region(collapsed) Carrossel Specification */
        if (window.innerWidth >= 1024) {
            const animation = { duration: 10000, easing: (t) => t };
            this.Utils.initSlider(this.sliderSpecifications, {
                loop: true,
                renderMode: "performance",
                drag: false,
                slides: {
                    perView: 6,
                },
                created(s) {
                    s.moveToIdx(5, true, animation);
                },
                updated(s) {
                    s.moveToIdx(s.track.details.abs + 5, true, animation);
                },
                animationEnded(s) {
                    s.moveToIdx(s.track.details.abs + 5, true, animation);
                },
            });
        }
        /* #endregion */

        this.Utils.initSlider(this.sliderTags, {
            mode: "free",
            slides: {
                spacing: 15,
            },
        });

        /* #region(collapsed) Product Page Slider */
        const sliderProduct = this.Utils.initSlider(
            this.sliderProduct,
            {
                loop: true, 
            },
            this.Utils.composer(
                this.Utils.navigationSliders,
                window.innerWidth >= 724 ? 
                    this.Utils.autoSwitch : () => {},
            ),
        );
        if (sliderProduct) {
            sliderProduct.on("created", () =>
                this.Utils.handleVideoPlayback(sliderProduct),
            );
            sliderProduct.on("slideChanged", () =>
                this.Utils.handleVideoPlayback(sliderProduct),
            );
        }

        this.Utils.initSlider(
            this.thumbnails,
            {
                initial: 0,
                slides: {
                    perView: 4,
                    spacing: 10,
                },
            },
            this.Utils.thumbnailPlugin(sliderProduct),
        );
        /* #endregion */

        this.Utils.initSlider(
            this.sliderRollon,
            {
                slides: { perView: 1.2, spacing: 15 },
                breakpoints: {
                    "(min-width: 1024px)": {
                        slides: { perView: 4, spacing: 15 },
                    },
                },
            },
            this.Utils.navigationSliders,
        );

        this.Utils.initSlider(
            this.sliderSpray,
            {
                slides: { perView: 1.2, spacing: 15 },
                breakpoints: {
                    "(min-width: 1024px)": {
                        slides: { perView: 4, spacing: 15 },
                    },
                },
            },
            this.Utils.navigationSliders,
        );

        this.Utils.initSlider(
            this.sliderStick,
            {
                slides: { perView: 1.2, spacing: 15 },
                breakpoints: {
                    "(min-width: 1024px)": {
                        slides: { perView: 4, spacing: 15 },
                    },
                },
            },
            this.Utils.navigationSliders,
        );

        const optionsAbout = {
            mode: "snap",
            rtl: false,
            slides: { perView: "auto", spacing: 15 },
        };

        this.Utils.initSlider(
            this.sliderAbout,
            optionsAbout,
            this.Utils.navigationSliders,
        );

        this.Utils.initSlider(
            this.sliderSpecialities,
            { origin: "center", perView: 1, spacing: 15 },
            this.Utils.navigationSliders,
        );
    },

    initJudgemeReviewTexts: function () {
        const wrapper = document.querySelector(
            "[data-jm-title], [data-jm-empty-text], [data-jm-write-btn]",
        );
        if (!wrapper) return;

        const overrides = [
            { attr: "jmTitle", selector: ".jm-review-widget-header__title" },
            { attr: "jmEmptyText", selector: ".jm-no-reviews-state__text" },
            { attr: "jmWriteBtn", selector: '[data-testid="write-review-button"]' },
        ];

        overrides.forEach(({ attr, selector }) => {
            const text = wrapper.dataset[attr];
            if (!text) return;

            this.Utils.waitForElement(selector, { timeout: 8000 })
                .then((el) => {
                    el.textContent = text;
                })
                .catch(() => {});
        });
    },

    Utils: {
        initSlider: function (selector, options, navigation = () => {}) {
            if (selector) {
                return new KeenSlider(selector, options, [navigation]);
            }
        },

        navigationSliders: function navigation(slider) {
            let arrowLeft, arrowRight;

            function markup(remove) {
                arrowMarkup(remove);
            }

            function removeElement(elment) {
                elment.parentNode.removeChild(elment);
            }

            function arrowMarkup(remove) {
                if (remove) {
                    removeElement(arrowLeft);
                    removeElement(arrowRight);
                    return;
                }
                arrowLeft = document.getElementById(
                    `${slider.container.id}--arrow-left`,
                );
                arrowLeft.addEventListener("click", () => slider.prev());
                arrowRight = document.getElementById(
                    `${slider.container.id}--arrow-right`,
                );
                arrowRight.addEventListener("click", () => slider.next());
            }

            function updateClasses() {
                var slide = slider.track.details.rel;
                slide === 0
                    ? arrowLeft.classList.add("arrow--disabled")
                    : arrowLeft.classList.remove("arrow--disabled");
                slide === slider.track.details.slides.length - 1
                    ? arrowRight.classList.add("arrow--disabled")
                    : arrowRight.classList.remove("arrow--disabled");
            }

            slider.on("created", () => {
                markup();
                updateClasses();
            });
            slider.on("optionsChanged", () => {
                console.log(2);
                markup(true);
                markup();
                updateClasses();
            });
            slider.on("slideChanged", () => {
                updateClasses();
            });
            slider.on("destroyed", () => {
                markup(true);
            });
        },

        navigationSliderOnlyDots: function navigation(slider) {
            let dots;

            function markup(remove) {
                dotMarkup(remove);
            }

            function removeElement(elment) {
                elment.parentNode.removeChild(elment);
            }

            function createDiv(className) {
                var div = document.createElement("div");
                var classNames = className.split(" ");
                classNames.forEach((name) => div.classList.add(name));
                return div;
            }

            function dotMarkup(remove) {
                if (remove) {
                    removeElement(dots);
                    return;
                }
                dots = document.getElementById(`${slider.container.id}--dots`);
                slider.track.details.slides.forEach((_e, idx) => {
                    var dot = createDiv("dot");
                    dot.addEventListener("click", () => slider.moveToIdx(idx));
                    dots.appendChild(dot);
                });
            }

            function updateClasses() {
                var slide = slider.track.details.rel;
                Array.from(dots.children).forEach(function (dot, idx) {
                    idx === slide
                        ? dot.classList.add("dot--active")
                        : dot.classList.remove("dot--active");
                });
            }

            slider.on("created", () => {
                markup();
                updateClasses();
            });
            slider.on("optionsChanged", () => {
                console.log(2);
                markup(true);
                markup();
                updateClasses();
            });
            slider.on("slideChanged", () => {
                updateClasses();
            });
            slider.on("destroyed", () => {
                markup(true);
            });
        },

        waitForElement: function (selector, { timeout = 5000 } = {}) {
            return new Promise((resolve, reject) => {
                const initial = document.querySelector(selector);
                if (initial) return resolve(initial);

                const observer = new MutationObserver(() => {
                    const el = document.querySelector(selector);
                    if (el) {
                        observer.disconnect();
                        resolve(el);
                    }
                });

                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                });

                setTimeout(() => {
                    observer.disconnect();
                    reject(`Elemento ${selector} não apareceu em ${timeout}ms`);
                }, timeout);
            });
        },

        thumbnailPlugin: function (main) {
            return (slider) => {
                function removeActive() {
                    slider.slides.forEach((slide) => {
                        slide.classList.remove("active");
                    });
                }
                function addActive(idx) {
                    slider.slides[idx].classList.add("active");
                }

                function addClickEvents() {
                    slider.slides.forEach((slide, idx) => {
                        slide.addEventListener("click", () => {
                            main.moveToIdx(idx);
                        });
                    });
                }

                slider.on("created", () => {
                    addActive(slider.track.details.rel);
                    addClickEvents();
                    main.on("animationStarted", (main) => {
                        removeActive();
                        const next = main.animator.targetIdx || 0;
                        addActive(main.track.absToRel(next));
                        slider.moveToIdx(
                            Math.min(slider.track.details.maxIdx, next),
                        );
                    });
                });
            };
        },

        handleVideoPlayback: function (slider) {
            if (!slider || !slider.slides) return;

            const slides = slider.slides;
            const activeIdx = slider.track.details.rel; // Índice do slide ativo

            slides.forEach((slide, index) => {
                const nativeVideo = slide.querySelector("video");
                const iframe = slide.querySelector("iframe");

                if (index === activeIdx) {
                    // --- SLIDE ATIVO (Carregar e Dar Play) ---
                    if (nativeVideo) {
                        // Lazy Load: Injeta o src apenas na primeira vez que o slide fica ativo
                        if (
                            nativeVideo.hasAttribute("data-src") &&
                            !nativeVideo.src
                        ) {
                            nativeVideo.src =
                                nativeVideo.getAttribute("data-src");
                            nativeVideo.load();
                        }
                        const playPromise = nativeVideo.play();
                        if (playPromise !== undefined) {
                            playPromise.catch((e) =>
                                console.log(
                                    "Autoplay bloqueado pelo navegador ou vídeo ainda carregando:",
                                    e,
                                ),
                            );
                        }
                    }
                    // Suporte para YouTube/Vimeo
                    if (iframe) {
                        if (iframe.src.includes("youtube")) {
                            iframe.contentWindow.postMessage(
                                '{"event":"command","func":"playVideo","args":""}',
                                "*",
                            );
                        } else if (iframe.src.includes("vimeo")) {
                            iframe.contentWindow.postMessage(
                                '{"method":"play"}',
                                "*",
                            );
                        }
                    }
                } else {
                    // --- SLIDES INATIVOS (Pausar) ---
                    if (nativeVideo) {
                        nativeVideo.pause();
                    }
                    if (iframe) {
                        if (iframe.src.includes("youtube")) {
                            iframe.contentWindow.postMessage(
                                '{"event":"command","func":"pauseVideo","args":""}',
                                "*",
                            );
                        } else if (iframe.src.includes("vimeo")) {
                            iframe.contentWindow.postMessage(
                                '{"method":"pause"}',
                                "*",
                            );
                        }
                    }
                }
            });
        },

        autoSwitch: function (slider) {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
                clearTimeout(timeout);
            }
            function nextTimeout() {
                clearTimeout(timeout);
                if (mouseOver) return;
                timeout = setTimeout(() => {
                    slider.next();
                }, 2000);
            }
            slider.on("created", () => {
                slider.container.addEventListener("mouseover", () => {
                    mouseOver = true;
                    clearNextTimeout();
                });
                slider.container.addEventListener("mouseout", () => {
                    mouseOver = false;
                    nextTimeout();
                });
                nextTimeout();
            });
            slider.on("dragStarted", clearNextTimeout);
            slider.on("animationEnded", nextTimeout);
            slider.on("updated", nextTimeout);
        },

        validarCPF: function (cpf) {
            cpf = cpf.replace(/[^\d]+/g, "");
            if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

            let soma = 0;
            for (let i = 0; i < 9; i++) soma += parseInt(cpf[i]) * (10 - i);
            let resto = (soma * 10) % 11;
            if (resto === 10 || resto === 11) resto = 0;
            if (resto !== parseInt(cpf[9])) return false;

            soma = 0;
            for (let i = 0; i < 10; i++) soma += parseInt(cpf[i]) * (11 - i);
            resto = (soma * 10) % 11;
            if (resto === 10 || resto === 11) resto = 0;

            return resto === parseInt(cpf[10]);
        },

        composer: function (...plugins) {
            return (slider) => {
                plugins.forEach((plugin) => plugin(slider));
            };
        },
    },
};

document.addEventListener("DOMContentLoaded", () => {
    App.LandingPage.init();
    WishList.Main.init();
});
